/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./CCircularTimer.vue?vue&type=template&id=70fd9b6c"
import script from "./CCircularTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CCircularTimer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CCircularTimer.vue?vue&type=style&index=0&id=70fd9b6c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports